(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "ramda", "./locationAssertions", "@braindate/util/lib/assert", "../../base/l10n/util"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("ramda"), require("./locationAssertions"), require("@braindate/util/lib/assert"), require("../../base/l10n/util"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ramda, global.locationAssertions, global.assert, global.util);
    global.locationGetters = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _ramda, _locationAssertions, _assert, _util) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getLocationBraindateMeetingPoint = getLocationBraindateMeetingPoint;
  _exports.getLocationBraindatePods = getLocationBraindatePods;
  _exports.getLocationBraindatePodsNumber = getLocationBraindatePodsNumber;
  _exports.getLocationBraindateRanges = getLocationBraindateRanges;
  _exports.getLocationContext = getLocationContext;
  _exports.getLocationGroupBraindateCapacity = getLocationGroupBraindateCapacity;
  _exports.getLocationGroupBraindateMeetingPoint = getLocationGroupBraindateMeetingPoint;
  _exports.getLocationGroupBraindatePods = getLocationGroupBraindatePods;
  _exports.getLocationGroupBraindatePodsNumber = getLocationGroupBraindatePodsNumber;
  _exports.getLocationId = getLocationId;
  _exports.getLocationLabel = getLocationLabel;
  _exports.getLocationTimezone = getLocationTimezone;
  _exports.getLocationURL = getLocationURL;
  _exports.getLocationURLs = getLocationURLs;
  _exports.getLocationsCompatible = getLocationsCompatible;
  _exports.getLocationsSameGroupCapacity = getLocationsSameGroupCapacity;
  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  /**
   * Get the id of a location
   * @param   {Location} location - Location to get the id from
   * @returns {number} Id
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function getLocationId(location) {
    (0, _locationAssertions.assertLocation)(location);
    return location.id;
  }

  /**
   * Get the URL of a location
   * @param   {Location} location - Location to get the URL from
   * @returns {string} URL
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function getLocationURL(location) {
    (0, _locationAssertions.assertLocation)(location);
    return location.url;
  }

  /**
   * Get the location_context of a location
   * @param   {Location} location - Location to get the location_context from
   * @returns {string} location_context
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function getLocationContext(location) {
    (0, _locationAssertions.assertLocation)(location);
    return location.location_context;
  }

  /**
   * Get the URLs of a location
   * @param   {Location} location - Location to get the URLs from
   * @returns {LocationURLs} URLs
   *
   * @throws Will throw an exception if parameter is not an object or if attribute
   * is not an object
   */
  function getLocationURLs(location) {
    (0, _locationAssertions.assertLocation)(location);
    var urls = location.urls;
    (0, _locationAssertions.assertLocationURLs)(urls);
    return urls;
  }

  /**
   * Get the timezone of a location
   * @param   {Location} location - Location to get the timezone from
   * @returns {string} Timezone
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function getLocationTimezone(location) {
    (0, _locationAssertions.assertLocation)(location);
    return location.timezone;
  }

  /**
   * Get the ranges of a location
   * @param   {Location} location - Event to get the slots from
   * @returns {Array<BraindateRange>} List of BraindateRange
   *
   * @throws Will throw an exception if parameter is not an object or if attribute
   * is not an array
   */
  function getLocationBraindateRanges(location) {
    (0, _locationAssertions.assertLocation)(location);
    var ranges = location.braindate_ranges;
    (0, _locationAssertions.assertLocationBraindateRanges)(ranges);
    return ranges.flatMap(function (range) {
      var computedRanges = range.computed_ranges;
      if (!computedRanges) return [range];

      // $FlowIssue Flow can't determine the typing
      return computedRanges.map(function (computedRange) {
        return _objectSpread(_objectSpread(_objectSpread({}, range), computedRange), {}, {
          computed_ranges: null
        });
      });
    });
  }

  /**
   * Get the group braindate capacity of a location
   * @param   {Location} location - Location
   * @returns {number} Capacity
   *
   * @throws Will throw an exception if parameter is not an object or if attribute
   * is not an array
   */
  function getLocationGroupBraindateCapacity(location) {
    (0, _locationAssertions.assertLocation)(location);
    return location.group_braindate_capacity;
  }

  /**
   * Get the group braindate pods number of the location
   * @param   {Location} location - Location
   * @returns {number} Group pods numbers
   *
   * @throws Will throw an exception if parameter is not an object or if attribute
   * is not an array
   */
  function getLocationGroupBraindatePodsNumber(location) {
    (0, _locationAssertions.assertLocation)(location);
    return location.group_braindate_pods_number;
  }

  /**
   * Get the braindate pods number of the location
   * @param   {Location} location - Location
   * @returns {number} Pods numbers for 1:1
   *
   * @throws Will throw an exception if parameter is not an object or if attribute
   * is not an array
   */
  function getLocationBraindatePodsNumber(location) {
    (0, _locationAssertions.assertLocation)(location);
    return location.braindate_pods_number;
  }

  /*
   |------------------------------------------------------------------------------
   | Advanced getters
   |------------------------------------------------------------------------------
   */

  /**
   * Get the label of a location
   * @param   {Location} location - Location to get the label from
   * @param   {string} [locale] - Locale in which to get the label
   * @returns {string} Label
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function getLocationLabel(location, locale) {
    (0, _locationAssertions.assertLocation)(location);
    return (0, _util.getLocalizedData)(location, locale).label || "";
  }

  /**
   * Get the Braindate meeting point of a location
   * @param   {Location} location - Location to get the label from
   * @param   {string} [locale] - Locale in which to get the label
   * @returns {string} Braindate meeting point
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function getLocationBraindateMeetingPoint(location, locale) {
    (0, _locationAssertions.assertLocation)(location);
    return (0, _util.getLocalizedData)(location, locale).braindate_meeting_point || "";
  }

  /**
   * Get the Group Braindate meeting point of a location
   * @param   {Location} location - Location to get the label from
   * @param   {string} [locale] - Locale in which to get the label
   * @returns {string} Group Braindate meeting point
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function getLocationGroupBraindateMeetingPoint(location, locale) {
    (0, _locationAssertions.assertLocation)(location);
    return (0, _util.getLocalizedData)(location, locale).group_braindate_meeting_point || "";
  }

  /**
   * Get the Braindate pods of a location
   * @param   {Location} location - Location to get the label from
   * @param   {string} [locale] - Locale in which to get the label
   * @returns {Array<string>} Braindate pods
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function getLocationBraindatePods(location, locale) {
    (0, _locationAssertions.assertLocation)(location);
    return (0, _util.getLocalizedData)(location, locale).braindate_pods || [];
  }

  /**
   * Get the Group Braindate pods of a location
   * @param   {Location} location - Location to get the label from
   * @param   {string} [locale] - Locale in which to get the label
   * @returns {Array<string>} Group Braindate pods
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function getLocationGroupBraindatePods(location, locale) {
    (0, _locationAssertions.assertLocation)(location);
    return (0, _util.getLocalizedData)(location, locale).group_braindate_pods || [];
  }

  /**
   * Get all compatible location between two set of locations
   * @param   {Array<Location>} locationsA - Locations A
   * @param   {Array<Location>} locationsB - Locations B
   * @returns {Array<Location>} Compatible Locations
   */
  function getLocationsCompatible(locationsA, locationsB) {
    (0, _assert.assertArray)(locationsA, "locations");
    (0, _assert.assertArray)(locationsB, "locations");
    return locationsA.filter(function (topicLocation) {
      return locationsB.some(function (userLocation) {
        return getLocationId(userLocation) === getLocationId(topicLocation);
      });
    });
  }

  /**
   * Return the Group size capacity if they all have the same value, return null if they don't have the same value.
   * @param   {Array<Location>} locations - List of Locations
   * @returns {number|null} Common Group size capacity
   */
  function getLocationsSameGroupCapacity(locations) {
    (0, _assert.assertArray)(locations, "locations");
    var groupSizeList = locations.map(getLocationGroupBraindateCapacity);
    var uniqGroupSizes = (0, _ramda.uniq)(groupSizeList);
    if (uniqGroupSizes.length === 1) {
      return uniqGroupSizes[0];
    }
    return null;
  }
});